import {BrandType} from "../../definitions/types";
import {ImageModel} from "./imageModel";

export class BrandModel {
    private readonly _id: number;
    private readonly _name: string;
    private readonly _description?: string;
    private readonly _link?: string;
    private readonly _image?: ImageModel;

    constructor(public readonly brand: BrandType) {
        this._id = brand.id;
        this._name = brand.name;
        this._description = brand.description;
        this._link = brand.link;
        this._image = brand.image ? new ImageModel(brand.image) : undefined;
    }

    /**
     * @method id
     * @description Returns the id of the brand.
     * @returns {number}
     */
    public get id(): number {
        return this._id;
    }

    /**
     * @method name
     * @description Returns the name of the brand if it exists.
     * @returns {string}
     */
    public get name(): string {
        return this._name;
    }

    /**
     * @method description
     * @description Returns the description of the brand if it exists.
     * @returns {string | undefined}
     */
    public get description(): string | undefined {
        return this._description;
    }

    /**
     * @method link
     * @description Returns the link of the brand if it exists.
     * @returns {string | undefined}
     */
    public get link(): string | undefined {
        return this._link;
    }

    /**
     * @method image
     * @description Returns the image of the brand if it exists.
     * @returns {ImageModel | undefined}
     */
    public get image(): ImageModel | undefined {
        return this._image;
    }
}